import React from "react";
import Pagination from "react-bootstrap/Pagination";

const PaginationComponent = ({ response, setPaginate }) => {
    return (
        <Pagination>
            {response.data &&
                response.links.map((link) => (
                    <Pagination.Item
                        key={link.label}
                        active={link.active}
                        onClick={() => {
                            link.url !== null && setPaginate(link.url);
                        }}
                    >
                        {link.label}
                    </Pagination.Item>
                ))}
        </Pagination>
    );
};

export default PaginationComponent;
